// global styles
import './App.css'

import { HomeView } from './Views/HomeView/HomeView'

export const App = () => {
  return (
    <HomeView />
  )
}
